// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3LFeu","fileBtn":"File_fileBtn__2Km_k","closeBtn":"File_closeBtn__rdbAm","fileSelected":"File_fileSelected__Y9ymH","disabled":"File_disabled__lIv2l"};